import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconErrorFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconErrorFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3e19ee5ea0c4799952c56907b996355517e7a50c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'bae8cfaa5c872ac4563c568b59dfdca2f91e4f1f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '284f81519283161668edcea6c9257c162afa6f18', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.99 2a9 9 0 1 0 .02 18 9 9 0 0 0-.02-18m-.74 4.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM11 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-error-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-error-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-error-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconErrorFilled$1);
            }
            break;
    } });
}

const CosmosIconErrorFilled = CosmosIconErrorFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconErrorFilled, defineCustomElement };
